module.exports = __webpack_public_path__ + "static/media/control_entre_carga2.72c632e0.svg";